<template>

    <div v-if="project" class="share-project-modal-component-container">

        <loading v-if="displayLoader" v-bind:label="'Updating Share Hash. Please wait.'"></loading>

        <div class="project-name">
            {{ project.name }}
        </div>

        <div class="project-tracks-count text-stardust-grey">
            {{ project.trackcount }} Tracks.
        </div>

        <div class="form-group">

            <label for="projectFromEmailInput">
                Sender Email:
            </label>

            <input class="form-control" id="projectFromEmailInput" placeholder="me@example.com" v-model="fromEmail"/>

        </div>

        <div class="form-group">

            <label for="projectToEmailInput">
                Recipient Email (max. 3, comma-separated):
            </label>

            <input class="form-control" id="projectToEmailInput" placeholder="them@example.com" v-model="toEmail" />

        </div>

        <div class="form-group">

            <label for="projectFromEmailInput">
                Rename Project: (optional)
            </label>

            <input class="form-control" id="projectTitleEmailInput" placeholder="Share as:" v-model="title" autocomplete="false" />

        </div>

		 <div class="form-group">

            <label for="emailNotesInput">
                Project Notes:
            </label>

            <textarea class="form-control" id="emailNotesInput" placeholder="Email Notes (optional)" v-model="notes" cols="30" rows="3" />

         </div>

        <div class="form-group row" v-if="adminShareProject">

            <div class="col-sm-12 form-check">
                <input type="checkbox" value="1" v-model="guestDownload" class="form-control d-inline form-check-input" id="guestDownload" />
                <label for="guestDownload" class="form-check-label">Allow downloading without an account</label>
            </div>

        </div>

        <div class="form-group row" v-if="adminShareProject">

            <div class="col-sm-12">
                Downloads Enabled For: (Days)
                <input type="text" v-model="shareDays" class="form-control" />
            </div>

        </div>

        <a class="btn btn-raised btn-xl font-weight-semibold share-button" v-bind:class="{ 'btn-success': sharing, 'btn-danger': !sharing }" href="#" v-on:click.prevent="emailProject">
            <span v-if="!sharing">Share</span>
            <span v-if="sharing"><img src="/images/download-spinner.gif" alt="spinner" class="loading-icon">Sharing...</span>
        </a>

        <div class="form-group row">

            <div class="col-12">
                <label><br/><br/> <strong>Or</strong> share using the URL below</label>
                <textarea v-model="copiedProjectDetails" id="projectData" class="d-none"></textarea>
            </div>

            <div class="col-sm-10">
                <input class="form-control" type="text" :value="copiedProjectDetails" readonly />
            </div>

            <div class="col-sm-2 copy-project">

                <a href="#" class="btn btn-primary btn-block btn-sm copy-project-details-button" v-bind:class="{ 'btn-success': copied }"
                   data-clipboard-action="copy" data-clipboard-target="#projectData">
                    <span v-if="!copied">Copy</span>
                    <span v-if="copied">Copied</span>
                </a>

            </div>

        </div>

    </div>

</template>

<script>

	import Vue from 'vue';
    import Clipboard from 'clipboard';
	import { playerService } from '../player-service';
    import LoadingComponent from '../components/loading';

	export default Vue.component(
	  'share-project',
        {

            data: function () {

                return {
                    project: null,
                    notes: null,
                    toEmail: null,
                    title: null,
                    shareDays: 10,
                    fromEmail: typeof window.authenticatedUserEmail === "undefined" ? null : window.authenticatedUserEmail,
                    copied: false,
                    copiedProjectDetails: null,
                    clipboardPlugin: null,
                    adminShareProject: false,
                    displayLoader: false,
                    guestDownload: 0,
                    sharing: false
                };

            },

            mounted: function () {

                this.adminShareProject = window.adminProjectShare;

                playerService.$on( 'user-updated', () => {

                    this.adminShareProject = window.adminProjectShare;
                    this.fromEmail = typeof window.authenticatedUserEmail === "undefined" ? null : window.authenticatedUserEmail;

                } );

                playerService.$on( 'sharing-failed', () => {
                    this.sharing = false;
                } );

                // Change the edit project contents depending on whats passed to it.
                playerService.$on(
                    'share-project',
                    (project) => {

                        this.copied = false;

                        this.sharing = false;

                        // Update curr track for modal.
                        this.project = project;

                        // Open the modal.
                        window.webpackOpenBsModalWorkaround('#shareProjectModal');

                        this.reset();

                        if(this.fromEmail && window.authenticatedUserEmail != false) {
                            setTimeout(function() {
                                $('#projectFromEmailInput').attr('readonly', true);
                            }, 250);
                        }
                    }
                );
            },

            methods: {

                emailProject: function () {

                    this.sharing = true;

                    playerService.emailProject(this.project, this.toEmail, this.fromEmail, this.notes, this.title, this.guestDownload );

                },

                copy: function () {

                    this.copied = true;

                },

                getWindowUrl: function () {
                    if (!window.location.origin) {
                        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                    }

                    return window.location.origin;

                },

                reset: function () {

                    this.notes = null;
                    this.toEmail = null;
                    this.fromEmail = null;
                    this.title = null;

                    if (window.authenticatedUserEmail != false) {
                        this.fromEmail = window.authenticatedUserEmail;
                    }

                    this.getShareHash();

                },

                getShareHash: function() {

                    this.displayLoader = true;

                    let ctx = this;
                    let url = `/api/projects/generate-share/${ this.project.id }`;
                    let method = 'GET';
                    let data = {};
                    let shareUrl = '/player?view-shared-project=';
                    let shareDays = false;

                    if( this.adminShareProject ) {
                        data['shareDays'] = this.shareDays;

                        if(this.guestDownload){
                            data['guest_download'] = this.guestDownload;
                        }
                    }

                    //Allow share of quicklist for guest users
                    if(typeof this.project.id === 'undefined'){
                        url = `/api/projects/generate-anon-share`;
                        method = 'POST';
                        data = {"trackIds" : window.quicklistTrackIds};
                        shareUrl = '/player?view-shared-quicklist=';
                    }

                    // Fetch new share url from database
                    $.ajax({
                        method: method,
                        url: url,
                        cache: false,
                        data: data,
                        dataType:'json'
                    }).done(function (response) {

                        // Setup the contents of the textarea.
                        let constructedUrl = ctx.getWindowUrl() + shareUrl + response.data;

                        if(ctx.guestDownload){
                            constructedUrl += '&allow-guest-download=true';
                        }

                        ctx.copiedProjectDetails = constructedUrl;

                        window.sharehash = response.data;

                        if (ctx.clipboardPlugin) {
                            ctx.clipboardPlugin.destroy();
                        }

                        ctx.clipboardPlugin = new Clipboard('.copy-project-details-button', {
                            container: document.getElementById('shareProjectModal'),
                            text: function (trigger) {
                                return ctx.copiedProjectDetails
                            }
                        });

                        this.copied = false;

                        ctx.clipboardPlugin.on('success', function (e) {

                            ctx.copied = true;

                            e.clearSelection();
                        });

                    }).always(function( response ) {
                        ctx.displayLoader = false;
                    });

                }

            },
            watch: {

                project: function (value) {
                    this.reset();
                },

                shareDays: function( value ) {

                    this.getShareHash();

                },

                guestDownload: function( value ) {

                    this.getShareHash();

                }

            },

            components: {
                'loading': LoadingComponent
            }
        }
	);

</script>
